import moment from 'moment';

import { FETCH_CLIENT, SET_CLIENT, LOG_OUT } from '../constants';
import { createOrganisationsDictionary } from '../../utilities/report-helpers';

const initialState = {
  clientDataLoaded: false,
  totalDataDateRangeInDays: null,
  showHomePage: false,
};

const parseClientData = data => {
  const organisationsDictionary = createOrganisationsDictionary(
    data.categories
  );
  const totalDataDateRangeInDays =
    data.lastEventTS && data.firstEventTS
      ? moment(data.lastEventTS).diff(moment(data.firstEventTS), 'days') + 1
      : null;

    const showHomePage = data.props.homePage || false;

  return {
    organisationsDictionary,
    totalDataDateRangeInDays,
    showHomePage,
  };

};

const client = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case FETCH_CLIENT:
      return {
        ...state,
        clientDataLoaded: false,
      };
    case SET_CLIENT:
      return {
        ...state,
        ...action.data,
        clientDataLoaded: true,
        ...parseClientData(action.data),
      };
    default:
      return state;
  }
};

export default client;
